function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.12,
    height: 9.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 4.67
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.34,
    width: 23.12,
    height: 24.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 21.53
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.72,
    width: 23.12,
    height: 28.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6240000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 47.85
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61.98,
    width: 23.12,
    height: 31.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6240000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 77.725
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 93.46,
    width: 23.12,
    height: 39.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.568888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 113.22
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.99,
    width: 23.12,
    height: 39.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 152.84
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.69,
    width: 23.12,
    height: 44.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 194.695
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.7,
    width: 23.12,
    height: 47.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 240.54
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 264.38,
    width: 23.12,
    height: 48.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 288.82
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 313.26,
    width: 23.12,
    height: 50.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6240000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 338.275
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.29,
    width: 23.12,
    height: 50.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 388.65500000000003
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 414.02,
    width: 23.12,
    height: 54.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3120000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 441.22999999999996
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.45,
    width: 23.12,
    height: 55.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 496.34
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.22,
    width: 23.12,
    height: 57.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 553.12
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 582.02,
    width: 23.12,
    height: 58.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 611.385
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.75,
    width: 23.12,
    height: 59.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 670.375
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 0,
    width: 34.3,
    height: 41.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.269999999999996,
    y: 20.85
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.42,
    y: 0,
    width: 35.83,
    height: 41.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1659999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.33500000000001,
    y: 20.85
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.25,
    y: 0,
    width: 38.33,
    height: 41.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8329999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.41499999999999,
    y: 20.85
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.58,
    y: 0,
    width: 40.06,
    height: 41.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.676666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.61,
    y: 20.85
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.64,
    y: 0,
    width: 41.07,
    height: 41.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.867142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.17499999999998,
    y: 20.85
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.71,
    y: 0,
    width: 41.56,
    height: 41.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.49,
    y: 20.85
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.26,
    y: 0,
    width: 44.43,
    height: 41.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.47499999999997,
    y: 20.85
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.69,
    y: 0,
    width: 46.62,
    height: 41.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.957142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322,
    y: 20.85
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.31,
    y: 0,
    width: 47.16,
    height: 41.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.89,
    y: 20.85
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.47,
    y: 0,
    width: 48.34,
    height: 41.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.64000000000004,
    y: 20.85
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.81,
    y: 0,
    width: 49.09,
    height: 41.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.355,
    y: 20.85
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.9,
    y: 0,
    width: 49.4,
    height: 41.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.790909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.6,
    y: 20.85
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.3,
    y: 0,
    width: 50.88,
    height: 41.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.957142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.74,
    y: 20.85
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.17,
    y: 0,
    width: 51.73,
    height: 41.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.035,
    y: 20.85
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 0,
    width: 58.1,
    height: 41.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.957142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.9499999999999,
    y: 20.85
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 41.7,
    width: 62.11,
    height: 39.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.421111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 61.595
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 81.48,
    width: 62.11,
    height: 41.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 102.2
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 122.92,
    width: 62.11,
    height: 41.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.366
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 143.835
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 164.75,
    width: 62.11,
    height: 42.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.132857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 186.215
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 207.68,
    width: 62.11,
    height: 44.2,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 229.78
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 251.88,
    width: 62.11,
    height: 49.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 276.585
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 301.29,
    width: 62.11,
    height: 49.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 326.13
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 350.98,
    width: 62.11,
    height: 53.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.617142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 377.64000000000004
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 404.29,
    width: 62.11,
    height: 58.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 433.735
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 463.18,
    width: 62.11,
    height: 72.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6463636363636365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 499.355
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 535.53,
    width: 62.11,
    height: 75.75,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.211
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 573.405
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 611.28,
    width: 62.11,
    height: 88.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.175,
    y: 655.64
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.23,
    y: 41.7,
    width: 67.15,
    height: 84.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.191666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.805,
    y: 83.725
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.38,
    y: 41.7,
    width: 71.38,
    height: 84.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.896666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.07,
    y: 83.725
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.76,
    y: 41.7,
    width: 73.29,
    height: 84.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.405,
    y: 83.725
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.05,
    y: 41.7,
    width: 86.87,
    height: 84.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.50625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.485,
    y: 83.725
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.92,
    y: 41.7,
    width: 101.85,
    height: 84.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.50625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.845,
    y: 83.725
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.77,
    y: 41.7,
    width: 102.45,
    height: 84.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.50625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.995,
    y: 83.725
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.22,
    y: 41.7,
    width: 111.78,
    height: 84.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.11,
    y: 83.725
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.23,
    y: 125.74,
    width: 145.11,
    height: 67.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.176666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.78500000000003,
    y: 159.26999999999998
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.23,
    y: 192.8,
    width: 145.11,
    height: 73.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.78500000000003,
    y: 229.56
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.23,
    y: 266.32,
    width: 145.11,
    height: 97.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.78500000000003,
    y: 315.13
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.23,
    y: 363.94,
    width: 145.11,
    height: 159.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.185000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.78500000000003,
    y: 443.53
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.23,
    y: 523.12,
    width: 145.11,
    height: 176.88,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.022000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.78500000000003,
    y: 611.56
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.34,
    y: 125.74,
    width: 133.09,
    height: 201.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.09909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.885,
    y: 226.725
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.43,
    y: 125.74,
    width: 141.91,
    height: 201.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.4775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.385,
    y: 226.725
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.34,
    y: 125.74,
    width: 194.66,
    height: 201.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.443333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.67,
    y: 226.725
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.34,
    y: 327.71,
    width: 221.1,
    height: 185.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.89,
    y: 420.705
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.34,
    y: 513.7,
    width: 221.1,
    height: 186.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.89,
    y: 606.85
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.44,
    y: 327.71,
    width: 248.56,
    height: 167.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.72,
    y: 411.27
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.44,
    y: 494.83,
    width: 248.56,
    height: 205.17,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 41.034
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.72,
    y: 597.415
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2012);
export default __webpack_public_path__ + "static/media/2012.5f5f6f55bf0cb7ab1602d90e13bda4f1.svg";
export { ForwardRef as ReactComponent };